export default {
  values: {
    "webhook must not be empty": "webhook must not be empty",
    "defaultChannel must not be empty": "defaultChannel must not be empty",
    Webhook: "Webhook",
    "Default Channel": "Default Channel",
    DYNAMIC_RECORD_TYPE_DESCRIPTION: `(recommended) Dynamic Record uses Live.Settings to store data and exposes Pipes functions as "records.{qualifier}".`,
    DYNAMIC_LIVE_LOOKUP_TYPE_DESCRIPTION:
      "Dynamic Live Lookup uses Live Lookup as storage layer and inherits all its features and costs.",
    STATIC_TYPE_DESCRIPTION:
      "Static record is stored in memory and is not updated unless it is re-saved.",
    IDENTITY_TYPE_DESCRIPTION:
      "Identity Live Lookup is a Live Lookup that the return value is the same key provided for the given value.",
  },
};
